import React, { useEffect, useState } from 'react';

import { Col, Row, Form, Table } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import Sortable from 'sortablejs';

import './styles.css';

import Menu from '../../components/Menu';

import search from '../../assets/images/search.png';
import ativo from '../../assets/images/ativo.png';
import naoAtivo from '../../assets/images/naoativo.png';
import editar from '../../assets/images/edit.png';
import excluir from '../../assets/images/delete.png';
import api from '../../services/api';
import CustomModal from '../../components/CustomModal';
import { useAlert } from 'react-alert';

const Parceiros = () => {

  const [partners, setPartners] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [show, setShow] = useState(false);
  const [idDelete, setIdDelete] = useState(null);
  const [load, setLoad] = useState(false);
  const alert = useAlert();

  const getPartners = async (search = '') => {
    try {
      const { data: { resources }
      } = await api.get('admin/partner', { params: { search } });
      setPartners(resources);
      renderSortable(resources);
      setLoad(false);
    } catch (error) {
      setLoad(false);
      console.log(error.response);
    }
  }
  const updatePositionPartners = async (positions, items) => {
    try {
      setLoad(true);
      await api.post(`admin/partner/position`, {
        positions,
        items
      });
      setLoad(false);
    } catch (error) {
      setLoad(false);
    }
  }
  useEffect(() => getPartners(), []);

  const renderSortable = (items) => {
    if (items.length !== 0) {
      let el = document.getElementById('partners');
      Sortable.create(el, {
        animation: 200,
        store: {
          get: function (sortable) {
            // var order = localStorage.getItem(sortable.options.group.name);
            // return order ? order.split('|') : [];
          },
          set: function (sortable) {
            var order = sortable.toArray();
            updatePositionPartners(order, items);
          }
        }
      });
    }
  }

  const handleStatus = async id => {
    try {
      const { data: { resources }
      } = await api.post(`admin/partner/${id}/status`);
      setPartners(resources);
    } catch (error) {
      console.log(error);
    }
  }
  const handleDelete = async id => {
    setShow(true);
    setIdDelete(id);
  }
  const finishDelete = async () => {
    try {
      const { data: { resources }
      } = await api.delete(`admin/partner/${idDelete}`);
      setPartners(resources);
      alert.show("Dados removidos com sucesso!");
    } catch (error) {
      console.log(error);
    }
    setShow(false);
  }

  const handleSearch = (e) => {
    const value = e.target.value;
    setLoad(true);
    setSearchString(value);
    getPartners(value);
  }

  const handleShow = () => setShow(false);

  return (
    <div className="container-fluid">
      <CustomModal show={show} handleShow={handleShow} onDelete={finishDelete} />
      <Menu />
      <div className="content">
        <Row>
          <Col sm={12} className="col-title">
            <div className="titlePages">
              <h5>Parceiros</h5>
              <Link to="/parceiro/novo">
                <button className="btnYellow">NOVO</button>
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Form className="formSearch">
              <Form.Group controlId="formBasicEmail">
                <Form.Control type="text" placeholder="Buscar" name="search" value={searchString} onChange={handleSearch} />
                <button><img src={search} alt="Icon" /></button>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col sm={8}>
            {load &&
              <div className="load-table">
                <div className="loading"></div>
              </div>
            }
            <Table responsive>
              <thead>
                <tr>
                  <th className="tableLeft">Título</th>
                  <th>Ativo</th>
                  <th>Editar</th>
                  <th>Excluir</th>
                </tr>
              </thead>
              <tbody id="partners">
                {partners.map((partner, key) => (
                  <tr key={key} data-id={key}>
                    <td className="tableLeft">{partner.title}</td>
                    <td><img className="imgActive" src={partner.status === 1 ? ativo : naoAtivo} alt="Icon" onClick={() => handleStatus(partner.id)} />{partner.status === 1 ? 'Sim' : 'Não'}</td>
                    <td>
                      <Link to={`/parceiro/edit/${partner.id}`}>
                        <img className="imgEdit" src={editar} alt="Icon" />
                      </Link>
                    </td>
                    <td><img className="imgDelete" src={excluir} alt="Icon" onClick={() => handleDelete(partner.id)} /></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Parceiros;